import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import _imports_0 from '../../assets/scan-banner.png';
import _imports_1 from '../../assets/amount.png';
import _imports_2 from '../../assets/refund.png';
import _imports_3 from '../../assets/secure.png';

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "banner"
}, null, -1);

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, " 为保护您和对方车主的隐私，将建立隐私号码保护，本次通话将采用匿名的方式进行，双方均显示隐私号码 ", -1);

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "tips-amount"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {
    "width": "22px",
    "height": "22px",
    "margin-right": "6px"
  }
}), /*#__PURE__*/_createTextVNode(" 拨打电话0.5元/分钟，预付金额20元 ")], -1);

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "tips-amount",
  style: {
    "color": "#f53979"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  style: {
    "width": "22px",
    "height": "22px",
    "margin-right": "6px"
  }
}), /*#__PURE__*/_createTextVNode(" 未消费金额在通话结束后自动退回钱包 ")], -1);

const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, " 为保护您和对方车主的隐私，将建立隐私号码保护，本次通话将采用匿名的方式进行，双方均显示隐私号码 ", -1);

const _hoisted_6 = {
  class: "tips"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 获取车主联系方式，需支付 ");

const _hoisted_8 = {
  class: "blue-text"
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 元隐私保护服务费 ");

const _hoisted_10 = {
  key: 2,
  class: "tips"
};
const _hoisted_11 = {
  key: 2,
  class: "tips"
};
const _hoisted_12 = {
  style: {
    "margin": "30px 16px 16px 16px"
  }
};

const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 版本维护中，请使用微信扫码 ");

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 呼叫车主 ");

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 短信通知 ");

const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 开始拨打 ");

const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 开始拨打 ");

const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "secure",
  style: {
    "color": "#39b54a"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  style: {
    "width": "16px",
    "height": "16px",
    "margin-right": "3px"
  }
}), /*#__PURE__*/_createTextVNode(" 前5分钟免费，未接通不收费 ")], -1);

const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 开始拨打 ");

const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 短信通知 ");

const _hoisted_21 = {
  class: "wrapper",
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_22 = {
  class: "block"
};

const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "18px",
    "font-weight": "bold"
  }
}, " 用户服务及支付协议 ", -1);

const _hoisted_24 = {
  style: {
    "color": "#77736d",
    "margin-top": "20px"
  }
};

const _hoisted_25 = /*#__PURE__*/_createElementVNode("iframe", {
  style: {
    "border": "none",
    "width": "100%",
    "height": "160px",
    "overflow-x": "hidden",
    "overflow": "scroll"
  },
  src: "https://ncmweb.imxiandian.com/useragreement240825.html"
}, null, -1);

const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 同意本协议，立即支付 ");

const _hoisted_27 = {
  key: 0,
  style: {
    "width": "100%",
    "position": "fixed",
    "bottom": "30px",
    "font-size": "14px",
    "color": "#999999",
    "text-align": "center"
  }
};

const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 同意并授权 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");

  const _component_van_button = _resolveComponent("van-button");

  const _component_van_cell_group = _resolveComponent("van-cell-group");

  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_overlay = _resolveComponent("van-overlay");

  return _openBlock(), _createElementBlock("div", null, [_hoisted_1, _createVNode(_component_van_cell_group, {
    inset: "",
    style: {
      "margin-top": "10px"
    }
  }, {
    default: _withCtx(() => [_ctx.license_plate_number != '' ? (_openBlock(), _createBlock(_component_van_cell, {
      key: 0,
      title: '车牌号码：' + _ctx.license_plate_number,
      style: {
        "font-size": "22px",
        "line-height": "40px"
      }
    }, null, 8, ["title"])) : _createCommentVNode("", true), _ctx.client == 'wechat' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_ctx.need_auth == 1 && _ctx.is_auth == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_hoisted_2, _hoisted_3, _hoisted_4], 64)) : _ctx.need_pay == 1 && _ctx.contact_price > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("text", _hoisted_8, _toDisplayString(_ctx.contact_price), 1), _hoisted_9])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_10, " 为保护您和对方车主的隐私，将建立隐私号码保护，本次通话将采用匿名的方式进行，双方均显示隐私号码 "))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_11, " 为保护您和对方车主的隐私，将建立隐私号码保护，本次通话将采用匿名的方式进行，双方均显示隐私号码 ")), _createElementVNode("div", _hoisted_12, [_ctx.client == 'alipay' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_ctx.need_auth == 1 ? (_openBlock(), _createBlock(_component_van_button, {
      key: 0,
      class: "font-18",
      round: "",
      block: "",
      plain: "",
      hairline: "",
      type: "primary",
      style: {
        "margin-top": "15px"
      }
    }, {
      default: _withCtx(() => [_hoisted_13]),
      _: 1
    })) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createVNode(_component_van_button, {
      round: "",
      block: "",
      type: "primary",
      onClick: _ctx.onCallPhone,
      class: "font-18"
    }, {
      default: _withCtx(() => [_hoisted_14]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_van_button, {
      class: "font-18",
      round: "",
      block: "",
      plain: "",
      hairline: "",
      type: "primary",
      style: {
        "margin-top": "15px"
      },
      onClick: _ctx.onSendMessage
    }, {
      default: _withCtx(() => [_hoisted_15]),
      _: 1
    }, 8, ["onClick"])], 64))], 64)) : _ctx.client == 'wechat' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_ctx.need_pay == 1 ? (_openBlock(), _createBlock(_component_van_button, {
      key: 0,
      class: "font-18",
      round: "",
      block: "",
      type: "primary",
      style: {
        "margin-top": "50px",
        "margin-bottom": "30px"
      },
      onClick: _ctx.payCall
    }, {
      default: _withCtx(() => [_hoisted_16]),
      _: 1
    }, 8, ["onClick"])) : _ctx.need_auth == 1 && _ctx.is_auth == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createVNode(_component_van_button, {
      class: "font-18",
      round: "",
      block: "",
      type: "primary",
      onClick: _ctx.onAuthPay
    }, {
      default: _withCtx(() => [_hoisted_17]),
      _: 1
    }, 8, ["onClick"]), _hoisted_18], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [_createVNode(_component_van_button, {
      round: "",
      block: "",
      type: "primary",
      onClick: _ctx.onCallPhoneNvi,
      class: "font-18"
    }, {
      default: _withCtx(() => [_hoisted_19]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_van_button, {
      class: "font-18",
      round: "",
      block: "",
      plain: "",
      hairline: "",
      type: "primary",
      style: {
        "margin-top": "15px"
      },
      onClick: _ctx.onSendMessage
    }, {
      default: _withCtx(() => [_hoisted_20]),
      _: 1
    }, 8, ["onClick"])], 64))], 64)) : _createCommentVNode("", true)])]),
    _: 1
  }), _createVNode(_component_van_overlay, {
    show: _ctx.showOverlay
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
      style: {
        "margin-left": "230px",
        "margin-bottom": "5px"
      },
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.closeOverlay && _ctx.closeOverlay(...args))
    }, [_createVNode(_component_van_icon, {
      name: "close",
      color: "#e0e0e0",
      size: "26"
    })]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_hoisted_25, _createVNode(_component_van_button, {
      round: "",
      block: "",
      type: "primary",
      onClick: _ctx.onAuthPay,
      style: {
        "margin-top": "20px"
      }
    }, {
      default: _withCtx(() => [_hoisted_26]),
      _: 1
    }, 8, ["onClick"])])])])]),
    _: 1
  }, 8, ["show"]), _ctx.need_auth == 1 && _ctx.is_auth == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_hoisted_28, _createElementVNode("text", {
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.handleUserService && _ctx.handleUserService(...args)),
    style: {
      "color": "#1989fa"
    }
  }, " 《用户服务及支付协议》 ")])) : _createCommentVNode("", true)]);
}